module.exports = __webpack_public_path__ + "static/media/TUTORIAL-LANDSCAPE.6a883dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tutorial/img/TUTORIAL-LANDSCAPE.png
// module id = 307
// module chunks = 0